module.exports = __webpack_public_path__ + "img/imag6.870cad49.png";